<template>
  <div class="uk-flex uk-flex-column">
    <div class="audio-player-styling">
      <audio-player
        ref="audioPlayer"
        :audio-list="audioList.map(elm => elm.url)"
        theme-color="#3E332C"
        :show-next-button=false
        :show-prev-button=false
        :show-playback-rate=false
        :show-progress-bar=false
        :is-loop=false
      />
    </div>
    <span class="audio-header mobile-audio-header">LUISTER EEN VOICEMAIL</span>
  </div>
</template>

<script>
import AudioPlayer from '@liripeng/vue-audio-player';

export default {
  name: 'AudioBlockVoorbeeld.vue',
  components: {
    AudioPlayer,
  },
  data() {
    return {
      currentAudioName: '',
      audioList: [
        {
          name: 'voicedemo_voicemail',
          url: 'https://iungo-it.nl/mp3/Voicedemo_Voicemail.mp3',
        },
      ],
    };
  },
};
</script>

<style scoped>
img {
  width: 100%;
  max-width: 350px;
}

audio {
  width: 100%;
}
</style>
